export enum RoleLabel {
    superAdmin = 'Super Admin',
    agencyAdmin = 'Agency Admin',
    merchantAdmin = 'Merchant Admin',
    storeAdmin = 'Store Admin',
    employee = 'Employee'
}